import * as actions from "../action.constants";

const requestGroup = (pageUrl) => ({
  type: actions.REQUEST_GROUP_LIST_SAGA,
  pageUrl,
});

const requestGroupLabelValue = () => ({
  type: actions.REQUEST_GROUP_LABEL_VALUE_LIST,
});

const requestPermissionList = () => ({
  type: actions.REQUEST_PERMISSION_LIST,
});

const requestUserList = (excludeMe = false) => ({
  type: actions.REQUEST_USER_LIST,
  excludeMe,
});

const sendAddGroupModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_ADD_GROUP_DATA_SAGA,
  payload: data,
  callback,
});
const sendEditGroupModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_EDIT_GROUP_DATA_SAGA,
  payload: data,
  callback,
});
const deleteGroupData = (id, callback) => ({
  type: actions.REQUEST_DELETE_GROUP_SAGA,
  payload: id,
  callback,
});

export {
  requestGroup,
  requestGroupLabelValue,
  requestPermissionList,
  requestUserList,
  sendAddGroupModalData,
  deleteGroupData,
  sendEditGroupModalData,
};
